exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body {\n  margin: 0;\n  overflow: hidden;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none; /* Disable selection/copy in UIWebView */\n}\n\n#canvas-container {\n  width: 1024px;\n  height: 768px;\n  position: relative;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/css/game.css
// module id = 25
// module chunks = 0